import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-2 col-md-3 col-sm-3 col-3" }
const _hoisted_4 = { class: "col-lg-10 col-md-9 col-sm-9 col-9 pl-0 center m-0 py-0" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  style: {"text-align":"center"},
  class: "my-5"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-bold" }
const _hoisted_10 = {
  key: 0,
  class: "text-primary"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode("     ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_spinner = _resolveComponent("spinner")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (!_ctx.catalog)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_InputSwitch, {
              onChange: _ctx.setValues,
              modelValue: _ctx.v$.name.$model,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.name.$model) = $event))
            }, null, 8, ["onChange", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", {
              class: _normalizeClass(["switch-label", [
            _ctx.isRequired && !_ctx.v$.name.$model && _ctx.isSubmitted
              ? 'p-error'
              : _ctx.v$.name.$model
              ? 'p-success'
              : '',
          ]]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => {
            _ctx.v$.name.$model = !_ctx.v$.name.$model;
            _ctx.setValues();
          })
            }, _toDisplayString(_ctx.label), 3)
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_spinner, {
                text: "",
                color: _ctx.spinnerColor,
                textColor: _ctx.spinnerTextColor
              }, null, 8, ["color", "textColor"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.label), 1),
                (_ctx.origin === 'Steps')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Elige todas las opciones necesarias "))
                  : _createCommentVNode("", true)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catalogData, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-container",
                  key: item
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["row", [_ctx.origin === 'Steps' ? 'justify-content-center' : 'ml-3']]),
                    onClick: ($event: any) => (_ctx.check(item.id))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass([
              _ctx.selectedCatalog.includes(item.id) ? 'switches-check' : 'switches',
              {
                'p-invalid':
                  _ctx.isRequired && !_ctx.selectedCatalog.length && _ctx.isSubmitted,
              },
            ])
                    }, [
                      _createVNode(_component_Checkbox, {
                        id: item.ID,
                        modelValue: _ctx.selectedCatalog,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedCatalog) = $event)),
                        value: item.id
                      }, null, 8, ["id", "modelValue", "value"])
                    ], 2),
                    _hoisted_12,
                    _createElementVNode("span", {
                      class: _normalizeClass(["switch-label", [
              _ctx.selectedCatalog.includes(item.id) ? 'text-primary' : 'span',
              _ctx.isRequired && !_ctx.selectedCatalog.length && _ctx.isSubmitted
                ? 'p-error'
                : 'span',
            ]])
                    }, _toDisplayString(item.name), 3)
                  ], 10, _hoisted_11)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
}